const addTo = (state, action) => (state || []).concat([action.element]);
export default addTo;
